var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "trash-a",
    d: "M18.8571429,6.75 L18.099993,19.3300781 C18.0444685,20.2517605 17.2780413,21 16.3892997,21 L7.61070033,21 C6.72195871,21 5.95553153,20.2517605 5.90000698,19.3300781 L5.14285714,6.75 L18.8571429,6.75 Z M10.1428571,10 L9,10 L9,18 L10.1428571,18 L10.1428571,10 Z M15.1428571,10 L14,10 L14,18 L15.1428571,18 L15.1428571,10 Z M14.0398996,2 C14.3328334,2 14.6765485,2.22109795 14.8071289,2.49354744 L15.1428571,3.1875 L19.4285714,3.1875 C19.7440011,3.1875 20,3.45349884 20,3.78125 L20,4.96875 C20,5.29650116 19.7440011,5.5625 19.4285714,5.5625 L4.57142857,5.5625 C4.25599888,5.5625 4,5.29650116 4,4.96875 L4,3.78125 C4,3.45349884 4.25599888,3.1875 4.57142857,3.1875 L8.85714286,3.1875 L9.19287109,2.49354744 C9.3210798,2.22109795 9.66200474,2 9.9538923,2 L14.0398996,2 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#40B3DB",
    fillRule: "nonzero",
    xlinkHref: "#trash-a"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.68bdccf0.svg";
export { ForwardRef as ReactComponent };